document.addEventListener('DOMContentLoaded', function () {

  function observeShopifyForm() {
    (function () {
      const HOST_SELECTOR = 'shopify-forms-embed#app-embed';
      const TARGET_LABEL_TEXT = 'Submitted From Page';
        
      function handleField(shadow) {
        const labels = shadow.querySelectorAll('label');

        for (const label of labels) {
          if (label.textContent.trim().toLowerCase() === TARGET_LABEL_TEXT.toLowerCase()) {
            const fieldContainer = label.closest('div');
            if (!fieldContainer) return false;

            const input = fieldContainer.querySelector('input');
            if (!input) return false;

            // Autofill with page URL
            input.value = window.location.href;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));

            // Hide the entire field
            fieldContainer.style.display = 'none';

            console.log('✅ Submitted From Page autofilled & hidden');
            return true;
          }
        }
        return false;
      }

      function observeShadow(shadow) {
        if (handleField(shadow)) return;

        const shadowObserver = new MutationObserver(() => {
          if (handleField(shadow)) {
            shadowObserver.disconnect();
          }
        });

        shadowObserver.observe(shadow, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      function waitForShadow(host) {
        if (host.shadowRoot) {
          observeShadow(host.shadowRoot);
          return;
        }

        const hostObserver = new MutationObserver(() => {
          if (host.shadowRoot) {
            observeShadow(host.shadowRoot);
            hostObserver.disconnect();
          }
        });

        hostObserver.observe(host, { childList: true });
      }

      const docObserver = new MutationObserver(() => {
        const host = document.querySelector(HOST_SELECTOR);
        if (host) {
          waitForShadow(host);
          docObserver.disconnect();
        }
      });

      docObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    })();
  }

  // ✅ Run it after DOM is ready
  observeShopifyForm();

});